'use client';

import { normalizeCatalogHubPath } from '@repo/config';
import type { IChromeConfig } from '@repo/web-chrome/chrome-config/chrome-config';
import { resolveChromeHref } from '@repo/web-chrome/chrome-config/resolve-chrome-href';

interface IChromeRouter {
  push: (href: string) => void;
}

export function navigateToChromeHref(
  config: IChromeConfig | null,
  router: IChromeRouter,
  href: string,
): void {
  const crossOriginHref = config ? resolveChromeHref(config, href) : null;
  if (crossOriginHref) {
    window.location.assign(crossOriginHref);
    return;
  }
  router.push(config?.isCatalogApp ? normalizeCatalogHubPath(href) : href);
}
